type Size = { h: number; w: number }

type Position = { x: number; y: number }

type Area = { l: number; t: number; w: number; h: number }

type Markers = { tl: Position; tr: Position; bl: Position; br: Position }

type OriginalConfig = {
  ORIGINAL_SIZE: Size
  CORRECTED_SIZE: Size
  MARKERS: Markers
  ROTATE_QR_POS: Position
  NUM_CHECK_AREA: Area
}

type CorrectedConfig = {
  correctedSize: Size
  correctedMarkers: Markers
  correctedRotateQrPos: Position
  correctedNumCheckArea: Area
}

/**
 * 縦向き答案の設定
 */
const TATE_CONFIG: OriginalConfig = {
  /**
   * 補正前のサイズ
   */
  ORIGINAL_SIZE: { h: 1414, w: 1012 },
  /**
   * 補正後のサイズ
   */
  CORRECTED_SIZE: { h: 2336, w: 1652 },
  /**
   * 補正マーカーの位置
   */
  MARKERS: {
    tl: { x: 28.5, y: 28.5 },
    tr: { x: 982, y: 28.5 },
    bl: { x: 28.5, y: 1390 },
    br: { x: 982, y: 1390 }
  },
  /**
   * 回転QRの位置
   */
  ROTATE_QR_POS: {
    x: 984,
    y: 302
  },
  /**
   * チェック用数字の位置
   */
  NUM_CHECK_AREA: {
    l: 12,
    t: 80,
    w: 60,
    h: 25
  }
} as const

/**
 * 横向き答案の設定
 */
const YOKO_CONFIG: OriginalConfig = {
  /**
   * 補正前のサイズ
   */
  ORIGINAL_SIZE: { h: 1012, w: 1414 },
  /**
   * 補正後のサイズ
   */
  CORRECTED_SIZE: { h: 1652, w: 2336 },
  /**
   * 補正マーカーの位置
   */
  MARKERS: {
    tl: { x: 28.5, y: 28.5 },
    tr: { x: 1390, y: 28.5 },
    bl: { x: 28.5, y: 982 },
    br: { x: 1390, y: 982 }
  },
  /**
   * 回転QRの位置
   */
  ROTATE_QR_POS: {
    x: 1335,
    y: 180
  },
  /**
   * チェック用数字の位置
   */
  NUM_CHECK_AREA: {
    l: 1335,
    t: 180,
    w: 60,
    h: 25
  }
} as const

/**
 * 補正された答案の設定を取得します
 * @returns
 */
const getCorrectedConfig = (config: OriginalConfig): CorrectedConfig => {
  const tateRatio = config.CORRECTED_SIZE.h / config.ORIGINAL_SIZE.h
  const yokoRatio = config.CORRECTED_SIZE.w / config.ORIGINAL_SIZE.w

  return {
    correctedSize: config.CORRECTED_SIZE,
    correctedMarkers: {
      tl: {
        x: config.MARKERS.tl.x * yokoRatio,
        y: config.MARKERS.tl.y * tateRatio
      },
      tr: {
        x: config.MARKERS.tr.x * yokoRatio,
        y: config.MARKERS.tr.y * tateRatio
      },
      bl: {
        x: config.MARKERS.bl.x * yokoRatio,
        y: config.MARKERS.bl.y * tateRatio
      },
      br: {
        x: config.MARKERS.br.x * yokoRatio,
        y: config.MARKERS.br.y * tateRatio
      }
    },
    correctedRotateQrPos: {
      x: config.ROTATE_QR_POS.x * yokoRatio,
      y: config.ROTATE_QR_POS.y * tateRatio
    },
    correctedNumCheckArea: {
      l: config.NUM_CHECK_AREA.l * yokoRatio,
      t: config.NUM_CHECK_AREA.t * tateRatio,
      w: config.NUM_CHECK_AREA.w * yokoRatio,
      h: config.NUM_CHECK_AREA.h * tateRatio
    }
  }
}

/**
 * 補正された縦向き答案の設定を取得します
 * @returns
 */
export const tateConfig = getCorrectedConfig(TATE_CONFIG)

/**
 * 補正された横向き答案の設定を取得します
 * @returns
 */
export const yokoConfig = getCorrectedConfig(YOKO_CONFIG)
